import {ChangeDetectionStrategy, Component, computed} from '@angular/core';
import {NotificationPage} from "../multi-page-notification/multi-page-notification.component";
import {NotificationDialogContentComponent} from "../notification-dialog-content/notification-dialog-content.component";
import {marked} from "marked";
import {MessageNotificationDto} from "homey-housing-lottery-app-dto";

@Component({
  selector: 'homey-message-dialog-content',
  imports: [
    NotificationDialogContentComponent
  ],
  templateUrl: './message-dialog-content.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MessageDialogContentComponent extends NotificationPage<MessageNotificationDto> {
   protected readonly markdown = computed(
     () =>  marked.parse(this.data().message));
}
